class PushLogic_Theme {

    constructor() {
        this.scrollHandler();
        this.slideToHandler();
        this.moveTitle();
        this.cleanBodyID();
        this.collectionSideNavigation();
        this.initFranchiseMap();
        this.initStockistsMap();
        this.distanceChangeHandler();
        this.closeLoader();
        this.wholesalePageLock();
    }

    getUrlParameter(parameter) {
        const urlParams = new URLSearchParams(window.location.search);
        const queriedParameter = urlParams.get(parameter);
        if(queriedParameter) {
            return queriedParameter;
        }
    }

    closeLoader() {
        window.addEventListener('load', function () {
            const loader = this.document.getElementById('plgg-loader');
            loader.style.display = 'none';
        });
    }

    elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }

    scrollHandler() {
        var self = this;
        window.onscroll = function() {
            self.home_parallax();
            self.site_parallax();
        };
    }

    home_parallax() {
        var self = this;
        const hero = document.querySelector('.plgg-hero-banner');

        if(hero) {
            const layerTwo = hero.querySelector('[id=plgg-hero-layer-2]');
            const bannerContent = hero.querySelector('.banner__media');

            if(self.elementInViewport(hero)) {
                bannerContent.style.position = 'fixed';
                if(window.scrollY > 0) {
                    layerTwo.style.bottom = '-' + window.scrollY/75 + '%';
                } else {
                    layerTwo.style.bottom = 0;
                }
            } else {
                bannerContent.style.position = 'absolute';
                layerTwo.style.bottom = 0;
            }
        }
    }

    site_parallax() {
        var self = this;
        const hero = document.querySelector('.header-background');

        if(hero) {
            const layerTwo = hero.querySelector('.header-parallax-two');

            if(self.elementInViewport(hero)) {
                if(window.scrollY > 0) {
                    layerTwo.style.bottom = '-' + window.scrollY/20 + '%';
                } else {
                    layerTwo.style.bottom = '-1px';
                }
            } else {
                layerTwo.style.bottom = '-1px';
            }
        }
    }

    smoothScroll(target) {
        var scrollContainer = target;

        do {
            scrollContainer = scrollContainer.parentNode;
            if (!scrollContainer) return;
            scrollContainer.scrollTop += 1;
        } while (scrollContainer.scrollTop == 0);
    
        var targetY = 0;
        do {
            if (target == scrollContainer) break;
            targetY += target.offsetTop;
        } while (target = target.offsetParent);
    
        scroll = function(c, a, b, i) {
            i++; if (i > 30) return;
            c.scrollTop = a + (b - a) / 30 * i;
            setTimeout(function(){ scroll(c, a, b, i); }, 20);
        }

        scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
    }

    slideToHandler() {
        const self = this,
            newsletter = document.querySelector('#newsletter-sign-up-block'),
            newsletter_button = document.querySelector('a[href="#newsletter-sign-up-form"]');
        
        if(newsletter_button != null) {
            newsletter_button.addEventListener('click', function()
            {
                self.smoothScroll(newsletter);
            });
        }
    }

    moveTitle() {
        const self = this,
            body = document.querySelector('body'),
            header_wrapper = document.querySelector('.header-wrapper');

        if(body.id !== 'index-template') {
            if(body.id.includes('page')) {
                const title_wrapper = document.querySelector('.main-page-title');
                if(title_wrapper !== null) {
                    header_wrapper.appendChild(title_wrapper);
                }
            } else if(body.id == 'product-template') {
                const title_wrapper = document.querySelector('.product__title');
                if(title_wrapper !== null) {
                    header_wrapper.appendChild(title_wrapper);
                }
            } else if(body.id == 'collection-template') {
                const title_wrapper = document.querySelector('.collection-hero');
                if(title_wrapper !== null) {
                    header_wrapper.appendChild(title_wrapper);
                }
            } else if(body.id == 'cart-template') {
                const title_wrapper = document.querySelector('.title-wrapper-with-link');
                if(title_wrapper !== null) {
                    header_wrapper.appendChild(title_wrapper);
                }
            }
        }
    }

    cleanBodyID() {
        const body = document.querySelector('body');
        if(body.id.includes('.')) {
            body.id = body.id.replace('.', '-');
        }
    }

    getParents(elem, selector) {
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                };
        }

        var parents = [];

        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if (selector) {
                if (elem.matches(selector)) {
                    parents.push(elem);
                }
                continue;
            }
            parents.push(elem);
        }

        return parents;
    }

    slideUp(target, duration = 500) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout( () => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    slideDown(target, duration = 500) {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;   
        if (display === 'none')
        display = 'block';
        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout( () => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    slideToggle(target, duration = 500) {
        const self = this;
        if (window.getComputedStyle(target).display === 'none') {
            return self.slideDown(target, duration);
        } else {
            return self.slideUp(target, duration);
        }
    }

    getCurrentCoords() {
        if(sessionStorage.hasOwnProperty('plgg_current_coords')) {
            return JSON.parse(sessionStorage.getItem('plgg_current_coords'));
        }
        return false;
    }

    collectionSideNavigation() {
        const self = this,
            product_grid = document.querySelector('.plgg-product-grid'),
            chevron = document.querySelectorAll('.plgg-menu-chevron'),
            active_nav_item = document.querySelector('.plgg-active-collection'),
            nav_items = document.querySelectorAll('.plgg-collection'),
            parents_active = self.getParents(active_nav_item, '.plgg-submenu'),
            nav_toggle = document.getElementById('plgg-collection-nav-toggle'),
            nav_wrapper = document.getElementById('plgg-collection-navigation-wrapper');

        if(nav_wrapper)
        {
            const current_product_collections = nav_wrapper.dataset.productCollections;
            if(current_product_collections)
            {
                const collections_array = current_product_collections.split(' | ');
                nav_items.forEach(nav_item => {
                    if(collections_array.includes(nav_item.querySelector('a').textContent))
                    {
                        nav_item.classList.add('plgg-active-collection');
                        self.getParents(nav_item, '.plgg-submenu').forEach(sub_menu => {
                            self.slideDown(sub_menu);
                            sub_menu.parentNode.classList.add('plgg-menu-item-toggled');
                        });
                    }
                });
            }

            document.querySelectorAll('.plgg-menu-chevron').forEach(chevron => {
                chevron.addEventListener('click', event => {
                    self.slideToggle(chevron.parentNode.querySelector('.plgg-submenu'), 200);
                    if(chevron.parentNode.classList.contains('plgg-menu-item-toggled'))
                    {
                        chevron.parentNode.classList.remove('plgg-menu-item-toggled');
                    } else {
                        chevron.parentNode.classList.add('plgg-menu-item-toggled');
                    }
                });
            });

            parents_active.forEach(menu => {
                self.slideDown(menu);
                menu.parentNode.classList.add('plgg-menu-item-toggled');
            });

            nav_toggle.addEventListener('click', event => {
                if(product_grid)
                {
                    if(product_grid.classList.contains('plgg-collection-nav-wrapper-open'))
                    {
                        product_grid.classList.remove('plgg-collection-nav-wrapper-open');
                    } else {
                        product_grid.classList.add('plgg-collection-nav-wrapper-open');
                    }
                } else {
                    const product_view = document.querySelector('#plgg-product-main-grid');
                    if(product_view.classList.contains('plgg-collection-nav-wrapper-open'))
                    {
                        product_view.classList.remove('plgg-collection-nav-wrapper-open');
                    } else {
                        product_view.classList.add('plgg-collection-nav-wrapper-open');
                    }
                }
            });
        }
    }

    initFranchiseMap() {
        const self = this;
        const currentUrl = window.location.href;
        const endpoint = 'https://franchises.geekgaming.co.uk/storage/geojson/franchises.geojson';
        const isCurrentFranchise = localStorage.getItem('plgg_is_current_franchise');
        const map_wrapper = document.getElementById('plgg-fullscreen-map');

        if(map_wrapper) {
            const mapbox_access_token = map_wrapper.dataset.mapboxAccessToken;
            if(self.getUrlParameter('redirected') == 'true' || currentUrl.includes('?oseid=')) {
                localStorage.setItem('plgg_is_current_franchise', 'yes');
                map_wrapper.style.display = 'none';
            }

            if(isCurrentFranchise == null || isCurrentFranchise == 'no' && mapbox_access_token) {
                fetch(endpoint, {
                    method: 'GET'
                })
                .then(response => response.json())
                .then(response => {
                    if(response.features) {
                        console.log(response.features);
                        self.franchiseMap(response.features, mapbox_access_token);
                        self.franchisesGeolocation(response.features);
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                    map_wrapper.style.display = 'none';
                });
            } else {
                map_wrapper.style.display = 'none';
            }
        }
    }

    franchiseMap(features, mapboxAccessToken) {
        const self = this;
        mapboxgl.accessToken = mapboxAccessToken;

        const franchiseMap = document.getElementById('plgg-fullscreen-map');

        const map = new mapboxgl.Map({
            container: "plgg-franchise-map",
            style: "mapbox://styles/mapbox/dark-v10",
            zoom: 1.9,
            center: [11, 20]
        });

        map.on('load', () => {
            map.loadImage(
                'https://franchises.geekgaming.co.uk/storage/images/gg-map-marker.png',
                (error, image) => {
                    if (error) throw error;

                    map.addImage('custom-marker', image);

                    map.addSource("countries", {
                        type: "vector",
                        url: "mapbox://mapbox.country-boundaries-v1"
                    });

                    map.addSource('us-states', {
                        type: 'geojson',
                        data: 'https://franchises.geekgaming.co.uk/storage/geojson/us-states.geojson'
                    });

                    const colours = ['#198283','#99d8c9','#66c2a4','#41ae76','#238b45','#006d2c','#00441b'];

                    features.forEach((feature, index, array) => {
                        const random_colour = Math.floor(Math.random() * colours.length);

                        if(feature.properties.iso_code == 'US') {
                            if(feature.properties.us_states) {
                                feature.properties.us_states.forEach((state, state_index, array) => {
                                    map.addLayer({
                                        id: "us-state-" + state_index,
                                        type: "fill",
                                        source: "us-states",
                                        paint: {
                                            "fill-color": colours[random_colour],
                                            "fill-opacity": 0.3
                                        },
                                        'filter': ['any', ['in', 'NAME', state]]
                                    }, 'country-label');
        
                                    map.on('click', 'us-state-' + state_index, (e) => {
                                        const currentUrl = window.location.href;
                                        if(currentUrl.includes(feature.properties.website))
                                        {
                                            localStorage.setItem('plgg_is_current_franchise', 'yes');
                                            franchiseMap.style.display = 'none';
                                        } else {
                                            localStorage.setItem('plgg_is_current_franchise', 'no');
                                            window.location.href = feature.properties.website + '?redirected=true';
                                        }
                                    });
        
                                    map.on('mouseenter', 'us-state-' + state_index, () => {
                                        map.getCanvas().style.cursor = 'pointer';
                                    });
        
                                    map.on('mouseleave', 'us-state-' + state_index, () => {
                                        map.getCanvas().style.cursor = '';
                                    });
                                });
                            }
                        } else {
                            map.addLayer({
                                id: "franchise-" + index,
                                type: "fill",
                                source: "countries",
                                "source-layer": "country_boundaries",
                                paint: {
                                    "fill-color": colours[random_colour],
                                    "fill-opacity": 0.6
                                },
                                'filter': ['any', ['in', 'iso_3166_1', feature.properties.iso_code]]
                            }, 'country-label');

                            map.on('click', 'franchise-' + index, (e) => {
                                const currentUrl = window.location.href;
                                if(currentUrl.includes(feature.properties.website))
                                {
                                    localStorage.setItem('plgg_is_current_franchise', 'yes');
                                    franchiseMap.style.display = 'none';
                                } else {
                                    localStorage.setItem('plgg_is_current_franchise', 'no');
                                    window.location.href = feature.properties.website + '?redirected=true';
                                }
                            });

                            map.on('mouseenter', "franchise-" + index, () => {
                                map.getCanvas().style.cursor = 'pointer';
                            });
                            
                            map.on('mouseleave', "franchise-" + index, () => {
                                map.getCanvas().style.cursor = '';
                            });
                        }
                    });
                }
            );
        });
    }

    franchisesGeolocation(features) {
        const self = this;
        const franchiseMap = document.getElementById('plgg-fullscreen-map');
        const franchiseFooter = document.getElementById('plgg-fullscreen-map-footer');

        franchiseFooter.addEventListener('click', function() {
            if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(setGeolocation);
            }
        });
        function setGeolocation(position) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const currentCoordes = [longitude, latitude];
            const turfOptions = {units: 'miles'};
            const query = [];

            features.forEach((feature, index, array) => {
                const featureCoordinates = [feature.geometry.coordinates[0], feature.geometry.coordinates[1]];
                const distance = turf.distance(currentCoordes, featureCoordinates, turfOptions);
                query.push({website: feature.properties.website, distance: distance.toFixed(2)});
            });

            query.sort((a, b) => {
                return a.distance - b.distance;
            });

            const currentUrl = window.location.href;
            if(currentUrl.includes(query[0].website))
            {
                localStorage.setItem('plgg_is_current_franchise', 'yes');
                franchiseMap.style.display = 'none';
            } else {
                localStorage.setItem('plgg_is_current_franchise', 'no');
                window.location.href = query[0].website + '?redirected=true';
            }
        }
    }

    mapPopup(map, source) {
        map.on('click', source, (e) => {
            const coordinates = e.features[0].geometry.coordinates.slice();
            const description = e.features[0].properties.description;

            while(Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
            
            new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(description)
                .addTo(map);
        });
        
        map.on('mouseenter', source, () => {
            map.getCanvas().style.cursor = 'pointer';
        });
        
        map.on('mouseleave', source, () => {
            map.getCanvas().style.cursor = '';
        });
    }

    distanceAndRadius(lat, lng, map) {
        const center = turf.point([lng, lat]);
        const units = (sessionStorage.hasOwnProperty('plgg_radius_unit')) ? sessionStorage.getItem('plgg_radius_unit') : 'miles';
        const radius = (sessionStorage.hasOwnProperty('plgg_radius_amount')) ? parseInt(sessionStorage.getItem('plgg_radius_amount')) : 25;
        const options = {steps: 80, units: units};
        const circle = turf.circle(center, radius, options);

        if(map.getLayer('query-radius')) {
            map.removeLayer('query-radius');
        }

        if(map.getSource('query_circle_data')) {
            map.removeSource('query_circle_data');
        }
        
        map.addSource('query_circle_data', {
            type: 'geojson',
            data: circle,
        });
        
        map.addLayer({
            id: 'query-radius',
            type: 'fill',
            source: 'query_circle_data',
            paint: {
                'fill-color': '#198283',
                'fill-opacity': 0.2,
            },
        });

        const circleBounds = turf.bbox(map.getSource('query_circle_data')._data);
        map.fitBounds(circleBounds, {padding: 20});
    }

    distanceChangeHandler() {
        const self = this;
        const distanceAmount = document.getElementById('plgg-ds-select');
        const distanceUnit = document.getElementById('plgg-ds-unit');
        const stockistsResults = document.getElementById('plgg-stockist-results');
        const stockistsAutocomplete = document.getElementById('plgg-stockist-autocomplete');
        const distanceSwitcher = document.getElementById('plgg-distance-switcher');
        const searchInput = document.getElementById('plgg-ss-input');

        if(distanceAmount && distanceUnit) {

            distanceAmount.addEventListener('change', (event) => {
                stockistsAutocomplete.innerHTML = '';
                stockistsAutocomplete.style.zIndex = 1;
                stockistsResults.style.zIndex = 2;
                distanceSwitcher.style.display = 'none';
                searchInput.value = '';
                sessionStorage.setItem('plgg_radius_amount', distanceAmount.value);
                self.initStockistsMap();
            });

            distanceUnit.addEventListener('change', (event) => {
                stockistsAutocomplete.innerHTML = '';
                stockistsAutocomplete.style.zIndex = 1;
                stockistsResults.style.zIndex = 2;
                distanceSwitcher.style.display = 'none';
                searchInput.value = '';
                sessionStorage.setItem('plgg_radius_unit', distanceUnit.value);
                self.initStockistsMap();
            });

        }
    }

    distanceSwitcherActiveStates() {
        const distanceAmount = document.getElementById('plgg-ds-select');
        const distanceUnit = document.getElementById('plgg-ds-unit');
        if(sessionStorage.hasOwnProperty('plgg_radius_amount')) {
            distanceAmount.value = sessionStorage.getItem('plgg_radius_amount');
        }
        if(sessionStorage.hasOwnProperty('plgg_radius_unit')) {
            distanceUnit.value = sessionStorage.getItem('plgg_radius_unit');
        }
    }

    initStockistsMap() {
        const self = this;
        const stockist_map = document.getElementById('plgg-stockist-map-container');
        console.log('init stockist map');
        if(stockist_map) {
            const franchise_access_key = stockist_map.dataset.franchiseAccessKey;
            const mapbox_access_token = stockist_map.dataset.mapboxAccessToken;
            console.log('1');
            if(franchise_access_key && mapbox_access_token)
            {
                console.log('2');
                const api_auth_endpoint = 'https://franchises.geekgaming.co.uk/api/stockists/' + franchise_access_key;
                
                fetch(api_auth_endpoint, {
                    method: 'GET',
                })
                .then(franchise => franchise.json())
                .then(franchise => {
                    console.log('3');
                    if(franchise.dataset_id) {
                        console.log('4');
                        console.log(franchise);
                        const endpoint = 'https://franchises.geekgaming.co.uk/storage/geojson/' + franchise.dataset_id + '.geojson';
                        const searchInput = document.getElementById('plgg-ss-input');
                        const iso_code = searchInput.dataset.isoCode;
                        const country = searchInput.dataset.country;
        
                        if(sessionStorage.hasOwnProperty('plgg_current_location')) {
                            const searchInput = document.getElementById('plgg-ss-input');
                            searchInput.value = sessionStorage.getItem('plgg_current_location');
                        }
                        
                        fetch(endpoint, {
                            method: 'GET',
                        })
                        .then(dataset => dataset.json())
                        .then(dataset => {
                            if(dataset.features) {
                                console.log(dataset.features);
                                console.log('5');
                                const mapbox_geo_api = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURI(country) + '.json?access_token=' + mapbox_access_token;
        
                                fetch(mapbox_geo_api, {
                                    method: 'GET',
                                })
                                .then(geocoding => geocoding.json())
                                .then(geocoding => {
                                    if(geocoding.features) {
                                        self.stockistsMap(dataset, geocoding.features[0].center, mapbox_access_token);
                                    }
                                })
                                .catch(error => {
                                    console.error('There was an error!', error);
                                    stockist_map.style.display = 'none';
                                });
                            }
                        })
                        .catch(error => {
                            console.error('There was an error!', error);
                            stockist_map.style.display = 'none';
                        });
                    } else {
                        stockist_map.style.display = 'none';
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                    stockist_map.style.display = 'none';
                });
            } else {
                stockist_map.style.display = 'none';
            }
        }
    }

    stockistsMap(dataset, countryCenter, mapboxAccessToken) {
        const self = this;
        mapboxgl.accessToken = mapboxAccessToken;
        const stockistMap = document.getElementById('plgg-stockist-map-canvas');
        const bounds = new mapboxgl.LngLatBounds();
        const geoCoordinates = self.getCurrentCoords();
        let boundCounter = 0;
        let activeFilters = ['any'];

        const map = new mapboxgl.Map({
            container: "plgg-stockist-map-canvas",
            style: "mapbox://styles/mapbox/dark-v11",
            zoom: 1.9,
            center: countryCenter
        });

        map.on('load', () => {
            map.loadImage(
                'https://franchises.geekgaming.co.uk/storage/images/gg-map-marker.png',
                (error, image) => {
                    if (error) throw error;

                    if(geoCoordinates) {
                        const turfOptions = {
                            units: (sessionStorage.hasOwnProperty('plgg_radius_unit')) ? sessionStorage.getItem('plgg_radius_unit') : 'miles'
                        };
                        const radius = (sessionStorage.hasOwnProperty('plgg_radius_amount')) ? sessionStorage.getItem('plgg_radius_amount') : 25;
                        dataset.features.forEach((feature, index, array) => {
                            const distance = turf.distance(geoCoordinates, feature.geometry.coordinates, turfOptions);
                            if(Math.round(distance) <= radius) {
                                activeFilters.push(['==', 'title', feature.properties.title]);
                                bounds.extend(feature.geometry.coordinates);
                                ++boundCounter;
                            }
                        });
                    } else {
                        dataset.features.forEach((feature, index, array) => {
                            activeFilters.push(['==', 'title', feature.properties.title]);
                            bounds.extend(feature.geometry.coordinates);
                            ++boundCounter;
                        });
                    }

                    if(boundCounter > 1) {
                        map.fitBounds(bounds, {padding: 50});
                    } else if(boundCounter == 1) {
                        map.fitBounds(bounds, {padding: 50, maxZoom: 15});
                    }

                    map.addImage('plgg_map_marker', image);

                    map.addSource('plgg_stockists_geojson', {
                        type: 'geojson',
                        data: dataset
                    });

                    map.addLayer({
                        'id': 'plgg_stockists_markers',
                        'type': 'symbol',
                        'source': 'plgg_stockists_geojson',
                        'layout': {
                            'icon-image': 'plgg_map_marker',
                            'icon-size': 1,
                            'icon-allow-overlap': true
                        },
                        'filter': activeFilters
                    });

                    self.mapPopup(map, 'plgg_stockists_markers');
                    self.stockistMapGeocoding(dataset.features, map, mapboxAccessToken);
                    self.stockistsResults(dataset.features, map);
                    self.distanceSwitcherActiveStates();
                    self.stockistsGeolocation(dataset.features, mapboxAccessToken);

                    if(geoCoordinates) {
                        const distanceSwitcher = document.getElementById('plgg-distance-switcher');
                        map.setCenter(geoCoordinates);
                        self.distanceAndRadius(geoCoordinates[1], geoCoordinates[0], map);
                        distanceSwitcher.style.display = 'block';
                    }
                }
            );
        });
    }

    stockistsResults(features, map) {
        const resultsBlock = document.getElementById('plgg-stockist-results');
        let resultsHtml = '<ul class="plgg-results-list">';

        features.sort((a, b) => {
            let titleA = a.properties.title.toUpperCase(); 
            let titleB = b.properties.title.toUpperCase();
            if (titleA < titleB) {
                return -1;
            }
            if (titleA > titleB) {
                return 1;
            }

            return 0;
        });

        features.forEach((feature, index, array) => {
            const phoneNumberLabel = 0 + feature.properties.phone.replace(/\D/g, '').slice(-10);
            resultsHtml += '<li data-lng="' + feature.geometry.coordinates[0] + '" data-lat="' + feature.geometry.coordinates[1] + '">';
                resultsHtml += '<h4>' + feature.properties.title + '</h4>';
                resultsHtml += '<address>';
                    resultsHtml += feature.properties.street + ', ';
                    resultsHtml += feature.properties.city + ', ';
                    resultsHtml += feature.properties.region + ', ';
                    resultsHtml += feature.properties.postcode + '';
                resultsHtml += '</address>';
                resultsHtml += (feature.properties.phone) ? '<a href="tel:' + feature.properties.phone + '">Tel: ' + phoneNumberLabel + '</a>' : '';
                resultsHtml += (feature.properties.email) ? '<a href="mailto:' + feature.properties.email + '">Email: ' + feature.properties.email + '</a>' : '';
                resultsHtml += (feature.properties.website) ? '<a href="' + feature.properties.website + '">Web: ' + feature.properties.website + '</a>' : '';
            resultsHtml += '</li>';
        });

        resultsHtml += '</ul>';

        resultsBlock.innerHTML = resultsHtml;

        const resultsList = document.querySelectorAll('#plgg-stockist-results .plgg-results-list li');

        if(resultsList) {
            resultsList.forEach((item, index, array) => {
                const lng = item.dataset.lng;
                const lat = item.dataset.lat;
                item.addEventListener('mouseover', (event) => {
                    if(map.getSource('query_circle_data')) {
                        const circleBounds = turf.bbox(map.getSource('query_circle_data')._data);
                        map.setCenter([lng, lat]);
                        map.fitBounds(circleBounds, {padding: 20});
                    } else {
                        map.setCenter([lng, lat]);
                        map.setZoom(14);
                    }
                });
            });
        }
    }

    stockistMapGeocoding(stockists, map, mapboxAccessToken) {
        const self = this;
        const stockistsResults = document.getElementById('plgg-stockist-results');
        const stockistsAutocomplete = document.getElementById('plgg-stockist-autocomplete');
        const searchInput = document.getElementById('plgg-ss-input');
        const iso_code = searchInput.dataset.isoCode;
        const distanceSwitcher = document.getElementById('plgg-distance-switcher');

        searchInput.addEventListener('keyup', (event) => {
            if(event.isComposing || event.keyCode === 229) {
                return;
            }
            if(searchInput.value.length > 3) {
                const mapbox_geo_api = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURI(searchInput.value) + '.json?country=' + iso_code + '&types=region,postcode,place,locality,district&autocomplete=true&access_token=' + mapboxAccessToken;

                fetch(mapbox_geo_api, {
                    method: 'GET',
                })
                .then(response => response.json())
                .then(response => {
                    if(response.features) {
                        self.stockistMapAutocomplete(response.features, map);
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
            } else {
                sessionStorage.removeItem('plgg_current_location');
                sessionStorage.removeItem('plgg_current_coords');
                stockistsAutocomplete.innerHTML = '';
                stockistsAutocomplete.style.zIndex = 1;
                stockistsResults.style.zIndex = 2;
            }
        });

        searchInput.addEventListener('search', (event) => {
            sessionStorage.removeItem('plgg_current_location');
            sessionStorage.removeItem('plgg_current_coords');
            stockistsAutocomplete.innerHTML = '';
            stockistsAutocomplete.style.zIndex = 1;
            stockistsResults.style.zIndex = 2;
            distanceSwitcher.style.display = 'none';
            self.initStockistsMap();
        });
    }

    stockistMapAutocomplete(features, map) {
        const self = this;
        let autocompleteHtml = '<ul class="plgg-results-list">';
        const stockistsResults = document.getElementById('plgg-stockist-results');
        const stockistsAutocomplete = document.getElementById('plgg-stockist-autocomplete');
        const distanceSwitcher = document.getElementById('plgg-distance-switcher');

        features.forEach((feature, index, array) => {
            autocompleteHtml += '<li data-lng="' + feature.geometry.coordinates[0] + '" data-lat="' + feature.geometry.coordinates[1] + '"><address>' + feature.place_name + '</address></li>';
        });

        autocompleteHtml += '</ul>';

        stockistsAutocomplete.innerHTML = autocompleteHtml;
        stockistsAutocomplete.style.zIndex = 2;
        stockistsResults.style.zIndex = 1;

        const geoItem = document.querySelectorAll('#plgg-stockist-autocomplete .plgg-results-list li');

        if(geoItem) {
            geoItem.forEach((item, index, array) => {
                const lng = item.dataset.lng;
                const lat = item.dataset.lat;
                item.addEventListener('click', (event) => {
                    console.log('Clicked');
                    map.setCenter([lng, lat]);
                    map.setZoom(13);
                    self.distanceAndRadius(lat, lng, map);
                    distanceSwitcher.style.display = 'block';
                    sessionStorage.setItem('plgg_current_location', item.textContent);
                    sessionStorage.setItem('plgg_current_coords', JSON.stringify([lng, lat]));
                });
            });
        }
    }

    stockistsGeolocation(features, mapboxAccessToken) {
        const self = this;
        if(navigator.geolocation) {
            if(!sessionStorage.hasOwnProperty('plgg_geo_active')) {
                navigator.geolocation.getCurrentPosition(setGeolocation);
            }
            function setGeolocation(position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                const currentCoordes = [longitude, latitude];
                const endpoint = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + longitude + ',' + latitude + '.json?types=place&access_token=' + mapboxAccessToken;

                fetch(endpoint, {
                    method: 'GET',
                })
                .then(response => response.json())
                .then(response => {
                    if(response.features[0].place_name) {
                        sessionStorage.setItem('plgg_geo_active', 'yes');
                        sessionStorage.setItem('plgg_current_location', response.features[0].place_name);
                        sessionStorage.setItem('plgg_current_coords', JSON.stringify(currentCoordes));
                        self.initStockistsMap();
                    }
                })
                .catch(error => {
                    console.error('There was an error!', error);
                });
            }
        }
    }

    wholesalePageLock()
    {
        const current_path = window.location.pathname;
        const wholesale_path = '/apps/shop';
        const domain = window.location.hostname;
        const body = document.querySelector('body');
        let customer_tags = body.dataset.customerTags;
        let isWholesale = false;
        customer_tags = customer_tags.split('|');

        if(customer_tags)
        {
            customer_tags.forEach(tag => {
                if(tag.toLowerCase().includes('wholesale'))
                {
                    isWholesale = true;
                }
            });
        }

        if(isWholesale)
        {
            if(current_path == wholesale_path)
            {
                const wholesale_desktop_menu_item = '<li><a href="' + wholesale_path + '" class="header__menu-item list-menu__item link link--text focus-inset" aria-current="page"><span class="header__active-menu-item">Wholesale</span></a></li>';
                let header_menu = document.querySelector('.header__inline-menu .list-menu');
                header_menu.innerHTML = header_menu.innerHTML + wholesale_desktop_menu_item;

                const wholesale_mobile_menu_item = '<li><a href="' + wholesale_path + '" class="menu-drawer__menu-item list-menu__item link link--text focus-inset menu-drawer__menu-item--active">Wholesale</a></li>';
                let mobile_header_menu = document.querySelector('header-drawer .menu-drawer__menu');
                mobile_header_menu.innerHTML = mobile_header_menu.innerHTML + wholesale_mobile_menu_item;
            } else {
                const wholesale_desktop_menu_item = '<li><a href="' + wholesale_path + '" class="header__menu-item list-menu__item link link--text focus-inset" aria-current="page"><span>Wholesale</span></a></li>';
                let header_menu = document.querySelector('.header__inline-menu .list-menu');
                header_menu.innerHTML = header_menu.innerHTML + wholesale_desktop_menu_item;

                const wholesale_mobile_menu_item = '<li><a href="' + wholesale_path + '" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">Wholesale</a></li>';
                let mobile_header_menu = document.querySelector('header-drawer .menu-drawer__menu');
                mobile_header_menu.innerHTML = mobile_header_menu.innerHTML + wholesale_mobile_menu_item;
            }
        }

        if(!isWholesale && current_path == wholesale_path)
        {
            window.location.replace(window.location.protocol + '//' + domain);
        }
    }

}
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
new PushLogic_Theme;